





















import { Component, Prop, Vue } from 'vue-property-decorator';
import Dropdown from '@/components/atoms/Dropdown.vue';
import TaskMetadataArgHint from '@/components/atoms/TaskMetadataArgHint.vue';
import TaskMetadataArgLabel from '@/components/atoms/TaskMetadataArgLabel.vue';
import { TaskMetadataArgsHint, TaskMetadataArgsLabel } from '@/types/type';

@Component({
  components: { Dropdown, TaskMetadataArgHint, TaskMetadataArgLabel },
})
export default class DropdownWithLabelAndHint extends Vue {
  @Prop()
  private labels!: TaskMetadataArgsLabel[];

  @Prop()
  private hints!: TaskMetadataArgsHint[];

  @Prop({ required: false, default: '' })
  private sampleInput!: string;

  @Prop({ required: false, default: false })
  private isRequired!: boolean;

  @Prop()
  private options!: [string];

  @Prop()
  private isMultiple!: boolean;
}
